import styled, { css } from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import { minWidth } from '@wecasa/web-ui/src/styles/mixins';

export const StyledBasketContainer = styled.div`
  ${minWidth.md`
    padding: 0 ${toRem(20)};
  `}
`;

export const CategoryLine = styled.div`
  margin-bottom: ${toRem(20)};
`;

export const PrestationsList = styled.ul`
  margin: 0;
  padding: ${toRem(10)} 0 0 ${toRem(15)};
`;

export const PrestationsListElement = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${toRem(5)};
`;

export const SurchargeTitle = styled(Text.MDBold)`
  margin-bottom: ${toRem(10)};
`;

export const SurchargeLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 ${toRem(5)} ${toRem(15)};
`;

// TODO: Remove this component after basket rebranding
export const ContentLine = styled(Text)`
  display: block;
  padding: 0 ${toRem(15)};
  margin-bottom: ${toRem(6)};
  max-width: 80%;
`;

// TODO: Check if this component is still needed after full basket rebranding
export const CalculationWrapper = styled.div`
  border-top: ${toRem(1)} solid ${colors.neutral20};
  margin-top: ${toRem(15)};
`;

export const calculationLineStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0;
  white-space: nowrap;
`;

// only used in childcare, will remove to use calculationLineStyle when the prices api will be used in childcare
export const ChildcareCalculationLine = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${toRem(9)} 0;
  border-bottom: ${toRem(1)} solid ${colors.neutral20};
  white-space: nowrap;

  > span:first-of-type {
    margin-right: ${toRem(30)};
  }
`;

// TODO: Check if this component is still needed after full basket rebranding
export const TotalLine = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: ${toRem(20)};

  > span:last-of-type {
    margin-left: ${toRem(15)};
  }
`;

export const DaysList = styled.ul`
  padding: 0;
  margin: 0 0 0 ${toRem(25)};
`;

export const Day = styled.li`
  margin-bottom: ${toRem(15)};
`;

export const Slots = styled.div`
  margin-top: ${toRem(5)};
  display: flex;
  flex-wrap: wrap;
`;
